export type LineStructure = 'FLAT' | 'TREE'

export interface BreakdownLine {
  id?: number
  parent_id?: number | null
  is_leaf?: boolean
  quantity?: number | null
  breakdown_values?: Record<string, unknown> | null
}

export function isTree(lineStructure?: string | null): boolean {
  return lineStructure === 'TREE'
}

/** Only the lines that get quoted: a parent is a heading and never goes out. */
export function leafLines<T extends BreakdownLine>(lines: T[]): T[] {
  return lines.filter((line) => line.is_leaf !== false)
}

/** A child left at zero is kept in the request but never sent to a provider. */
export function isQuotable(line: Pick<BreakdownLine, 'quantity'>): boolean {
  return Number(line.quantity) > 0
}

/** "Las Condes", or "Taller 128 · Continautos" for a row named by several values; a master value reads as its name. */
export function breakdownLabel(values?: Record<string, unknown> | null): string {
  return Object.values(values ?? {})
    .map((value) => (value !== null && typeof value === 'object' ? String((value as { name?: unknown; id?: unknown }).name ?? (value as { id?: unknown }).id) : String(value)))
    .join(' · ')
}
